import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AuthTheme.css";
import API_BASE_URL from "../config";
import PasswordInput from "../components/PasswordInput";
import { BsArrowLeft, BsCheckCircleFill, BsXCircleFill, BsKeyFill } from "react-icons/bs";

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      setError("Invalid or missing reset token.");
      setLoading(false);
      return;
    }

    try {
      const res = await axios.post(`${API_BASE_URL}/reset-password`, { token, newPassword });
      setMessage(res.data.message);
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pf-auth pf-auth--center">
      <div className="pf-shell">
        <div className="pf-card">
          <div className="pf-card-icon"><BsKeyFill /></div>
          <div>
            <h1 className="pf-title">Set a new password</h1>
            <p className="pf-sub">Choose a strong password for your account.</p>
          </div>

          <form className="pf-form" onSubmit={handleSubmit}>
            <div className="pf-field">
              <label htmlFor="rp-pw">New password</label>
              <PasswordInput id="rp-pw" placeholder="Min 8 characters" value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)} autoComplete="new-password" required />
            </div>
            <button type="submit" className="pf-btn" disabled={loading}>
              {loading ? "Resetting..." : "Reset password"}
            </button>
          </form>

          {message && <div className="pf-msg pf-msg--ok"><BsCheckCircleFill /> {message}</div>}
          {error && <div className="pf-msg pf-msg--err"><BsXCircleFill /> {error}</div>}

          <button className="pf-link" style={{ display: "inline-flex", alignItems: "center", gap: "6px", alignSelf: "center" }}
            onClick={() => navigate("/login")}>
            <BsArrowLeft /> Back to sign in
          </button>
        </div>
      </div>
    </div>
  );
}
